<template>
  <div am-th-cell>
    <slot></slot>
    <div
      :am-resize="isResizing"
      @mousedown="startResize"
      @mouseup="stopResize"
      v-click-outside="stopResize"
    />
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'TableHeadCell',
  props: {
    index: {
      type: Number,
      required: true
    }
  },
  data: () => ({
    isResizing: false
  }),
  watch: {
    isResizing (val) {
      if (!val) {
        this.putSettings()
      }
    }
  },
  methods: {
    ...mapActions('ui', ['putSettings', 'resizeColumn']),
    startResize () {
      window.addEventListener('mousemove', this.mouseMove)
      this.isResizing = true
    },
    stopResize () {
      window.removeEventListener('mousemove', this.mouseMove)
      this.isResizing = false
    },
    mouseMove (e) {
      this.resizeColumn({
        subtable: this.$route.params.subtable,
        index: this.index,
        delta: e.movementX
      })
    }
  }
}
</script>

<style lang="scss">
 [am-th-cell] {
    box-sizing: border-box;
    padding: var(----spacing);
    border-right: var(--border-right-width) var(--border-style) var(--border-color);
    position: relative;
    user-select: none;
    white-space: nowrap;

    [am-resize] {
      position: absolute;
      width: 3px;
      height: 100%;
      top: 0;
      right: 0;
      cursor: col-resize;
      transition: background-color var(--transition-duration) var(--transition-easing);

      &:hover, [am-resize~="true"] {
        background: var(--color--info);
      }

    }
  }

  .-light {
    [am-th-cell] {
      background-color: var(--color--light-50);
    }
  }
  .-dark {
    [am-th-cell] {
      background-color: var(--color--dark-40);
    }
  }
</style>
